import { FormElementOption, ElementType } from "@/@types/entities/forms";

export const formElementOptions: FormElementOption[] = [
  {
    name: "Encabezado",
    description: "Úsalo para ingresar un título o texto descriptivo.",
    type: ElementType.Header,
  },
  {
    name: "Cargar archivo",
    description:
      "Úsalo para cargar archivos tipo jpg, png, csv, xlsx, pdf, txt y pdf. Peso máximo 3MB.",
    type: ElementType.File,
  },
  {
    name: "Texto corto",
    description: "Úsalo para capturar valores en una sola linea.",
    type: ElementType.ShortText,
  },
  {
    name: "Texto largo",
    description: "Úsalo para capturar valores de hasta 370 caractéres.",
    type: ElementType.LongText,
  },
  {
    name: "Opción única",
    description: "Úsalo para capturar un único valor de un conjunto de opciones.",
    type: ElementType.SingleOption,
  },
  {
    name: "Opción múltiple",
    description: "Úsalo para capturar varios valores de un conjunto de opciones.",
    type: ElementType.MultipleOptions,
  },
  {
    name: "Desplegable",
    description: "Úsalo para seleccionar un único valor de un conjunto de opciones",
    type: ElementType.Dropdown,
  },
  {
    name: "Recordatorio",
    description: "Úsalo para que el agente pueda crear un recordatorio.",
    type: ElementType.Reminder,
  },
  {
    name: "Fecha",
    description: "Úsalo para capturar valores de tipo fecha.",
    type: ElementType.Date,
  },
  {
    name: "Hora",
    description: "Úsalo para capturar valores de tipo hora.",
    type: ElementType.Hour,
  },
  {
    name: "Promesa de pago (PDP)",
    description: "Fecha y monto del compromiso de pago de determinada prestación.",
    type: ElementType.Pdp,
  },
];

export function getNameByType(type?: ElementType) {
  if (!type) return "Desconocido";

  const element = formElementOptions.find((opt) => opt.type === type);
  return element?.name;
}
